module.exports = __webpack_public_path__ + "img/KMD_WHITE.4f65109c.png";